import { createRouter } from '@tanstack/react-router';

import { trackNavigationOrigin } from '@/lib/navigation-origin';
import { trackPageViews } from '@/lib/page-view';
import { queryClient } from '@/lib/query-client';
import { routeErrorHandling } from '@/lib/route-error-handling';
import { routeTree } from '@/routeTree.gen';

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  scrollRestoration: true,
  scrollToTopSelectors: ['[data-app-scroll-container]'],
  context: { queryClient },
  ...routeErrorHandling,
});

trackNavigationOrigin(router);
trackPageViews(router);

export type Router = typeof router;
